import { InjectionToken } from '@angular/core';

/** Hidden column ids per table key. */
export type HiddenColumnsByTable = Record<string, string[]>;

/**
 * Where a table's column preference is kept.
 *
 * A token rather than a service of its own, for the same reason
 * `TABLE_IDENTIFY_BY` and `TABLE_GET_DETAILS` are tokens: the table knows
 * that somebody remembers this, not who, and a library of components has no
 * business holding the address of an endpoint. The application provides the
 * one that talks to the account; a test provides one that remembers nothing.
 *
 * Optional. Without it a table still offers the picker and still hides
 * columns — it simply has nowhere to put the answer, so it offers no
 * Save either.
 */
export interface TableColumnStore {
  /**
   * Every table at once.
   *
   * One call, because a page carrying two tables should not ask twice to
   * find out that neither has been configured.
   */
  load(): Promise<HiddenColumnsByTable>;
  save(table: string, hidden: readonly string[]): Promise<void>;
}

export const TABLE_COLUMN_STORE = new InjectionToken<TableColumnStore>(
  'TABLE_COLUMN_STORE',
);
